import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionGuard } from '../../../../@auth/permission.guard';
import { ChangeContractConfirmationComponent } from './change-contract-confirmation/change-contract-confirmation.component';
import { ContractConfirmationComponent } from './contract-confirmation.component';

const routes: Routes = [
  {
    path: '',
    component: ContractConfirmationComponent,
  },
  {
    path: 'edit/:id',
    component: ChangeContractConfirmationComponent,
    canActivate: [PermissionGuard],
    data: {
      accessControl: {
        permission: 'read',
        resource: 'suppliercontracts',
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractConfirmationRoutingModule {}
